import { createFileRoute } from '@tanstack/react-router';
import { ReportingWebhooksIndexRouteView } from '@/pages/workspaces/integrations/reporting-webhooks/routing';
import { LastWorkspaceResolver } from './-components';

function ReportingWebhooksIndexRoute() {
  // No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the
  // resolver rebuilds the target from the bundle prefix — which would find no `/journeys/` here,
  // drop the sub-path, and land on the Journeys home instead of this list. The plain
  // `/workspaces/last` → `/workspaces/<id>` replacement preserves it.
  return (
    <LastWorkspaceResolver>
      <ReportingWebhooksIndexRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/')({
  component: ReportingWebhooksIndexRoute,
});
